const STORAGE_KEY = 'emailLion_activation';

const DEFAULT = {
    connected: false,
    sent: false,
    aiReply: false,
    automation: false,
    dismissed: false,
};

export function getActivationProgress() {
    try {
        return { ...DEFAULT, ...JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') };
    } catch {
        return { ...DEFAULT };
    }
}

export function setActivationProgress(partial) {
    const next = { ...getActivationProgress(), ...partial };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    try {
        window.dispatchEvent(new CustomEvent('emailLion:activation', { detail: next }));
    } catch { /* ignore */ }
    return next;
}

export function markActivationStep(step) {
    if (!['connected', 'sent', 'aiReply', 'automation', 'dismissed'].includes(step)) return getActivationProgress();
    return setActivationProgress({ [step]: true });
}

export function isActivationComplete(progress = getActivationProgress()) {
    return progress.connected && progress.sent && progress.aiReply && progress.automation;
}

export function dismissActivation() {
    return setActivationProgress({ dismissed: true });
}
